import { CommentsWidget } from 'www/modules/comments/widget/comments-widget';

import CommentsWidgetSVG from 'www/svg-icons/comments-widget';
export class PromosCommentsWidget extends CommentsWidget {
    constructor(api) {
        super(api);
        this._labelContainer = null;
        this._iconContainer = null;
        this._linkEl = null;
        this._countEl = null;

    }
    init() {
        this.el.appendChild(this.linkEl);
        super.init();
    }
    get linkEl() {
        if (this._linkEl == null) {
            let linkEl = document.createElement('a');
            linkEl.appendChild(this.iconContainer);
            linkEl.appendChild(this.labelContainer);
            this._linkEl = linkEl;
        }
        return this._linkEl;
    }
    get labelText() {
        const count = this.api.state.count;
        const locale = window.locale || 'en';
        let commentText = "";
        if (locale === 'de') {      	
            
            if (count > 1) {
                commentText = 'Kommentare lesen';
            }else{
            	commentText = 'Kommentar lesen';
            }
            
        } else if (locale === 'fr') {
        	
        	if (count > 1) {
                commentText = 'Lire les commentaires';
            }else{
            	commentText = "Lire le commentaire";
            }
            
        } else if (locale === 'es') {
        	if (count > 1) {
                commentText = 'Leer comentarios';
            }else{
            	commentText = "Leer comentario";
            }
            
        } else if (locale === 'pt') {
            if (count > 1) {
                commentText = 'Ler comentários';
            }else{
            	commentText = "Ler comentário";
           }
            
        } else {
            commentText = "READ COMMENT";
            
            if (count > 1) {
                commentText += 'S';
            }
        }

        return `<span class="label-text">${commentText.toUpperCase()}</span>`;
    }
    get labelContainer() {
        if (this._labelContainer == null) {
            let labelContainer = document.createElement('span');
            labelContainer.classList.add('label-container');
            this._labelContainer = labelContainer;
        }
        return this._labelContainer;
    }
    get countEl() {
        if (this._countEl == null && typeof window.vfUuid != 'undefined') {
            let countEl = document.createElement('span');
            countEl.classList.add("count-number");
            countEl.classList.add("viafoura-commentcount");
			countEl.setAttribute('data-vf-section-uuid', window.vfUuid);
			countEl.setAttribute('data-vf-article-id', (PageMetadata.pageSegVars.art == '0' ? window.location.pathname.match(/\d+$/)[0] : PageMetadata.pageSegVars.art));			
            countEl.innerHTML = this.api.state.count;
            this._countEl = countEl;
        }
        return this._countEl;
    }
    get iconContainer() {
        if (this._iconContainer == null) {
            let iconContainer = document.createElement('span');
            iconContainer.classList.add('icon-container');
            iconContainer.insertAdjacentElement("beforeend", CommentsWidgetSVG.useSprite);
            iconContainer.appendChild(this.countEl);
            this._iconContainer = iconContainer;
        }
        return this._iconContainer;
    }
    handleCountChange(count = 0) {
        this.countEl.innerHTML = count;
        this.labelContainer.innerHTML = this.labelText;
    }

}